import { render } from "./SangriaModal.vue?vue&type=template&id=82eeba42&scoped=true"
import script from "./SangriaModal.vue?vue&type=script&lang=js"
export * from "./SangriaModal.vue?vue&type=script&lang=js"

import "./SangriaModal.vue?vue&type=style&index=0&id=82eeba42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82eeba42"]])

export default __exports__